<div [id]="blogContainerId" class="dinings-page-container">
  <app-small-header textColor="#fff" [homePage]="true"></app-small-header>

  <div class="hero-section">
    <div class="overlay"></div>

    <div class="hero-text">
      <p class="small-text">GRAINS PURE VEG BY</p>

      <div class="divider-line"></div>
      <span class="big-text">{{ diningData?.name }}</span>
      <div class="divider-line"></div>

      <p class="location">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.442"
          height="24.679"
          viewBox="0 0 17.442 24.679"
        >
          <g
            id="location_11_"
            data-name="location (11)"
            transform="translate(0.15 0.15)"
          >
            <path
              id="Path_49084"
              data-name="Path 49084"
              d="M83.977,24.061a.714.714,0,0,0,1.189,0c1.69-2.535,4.18-5.667,5.915-8.851a14.189,14.189,0,0,0,2.062-6.639A8.571,8.571,0,1,0,76,8.571a14.189,14.189,0,0,0,2.062,6.639C79.8,18.392,82.29,21.531,83.977,24.061Zm.594-22.633a7.15,7.15,0,0,1,7.142,7.142,12.853,12.853,0,0,1-1.888,5.956,89.839,89.839,0,0,1-5.255,7.87,89.835,89.835,0,0,1-5.255-7.87,12.853,12.853,0,0,1-1.888-5.956,7.15,7.15,0,0,1,7.142-7.142Z"
              transform="translate(-76)"
              fill="#fff"
              stroke="#fff"
              stroke-width="0.3"
            />
            <path
              id="Path_49085"
              data-name="Path 49085"
              d="M170.285,98.571A4.285,4.285,0,1,0,166,94.285,4.29,4.29,0,0,0,170.285,98.571Zm0-7.142a2.857,2.857,0,1,1-2.857,2.857A2.86,2.86,0,0,1,170.285,91.428Z"
              transform="translate(-161.715 -85.715)"
              fill="#fff"
              stroke="#fff"
              stroke-width="0.3"
            />
          </g>
        </svg>
        {{ diningData?.destination?.name }}
      </p>
    </div>
  </div>

  <div class="welcome-section">
    <h2>Welcome</h2>
    <p>
      {{ diningData?.description }}
    </p>

    <div class="timing-box">
      <div class="action-buttons">
        <button class="btn reserve" (click)="openReservePopup()">
          Reserve a Table
        </button>
        @if (showTakeaway) {
          <button class="btn takeaway" (click)="openTakeawayPopup()">
            Take Away
          </button>
        }
      </div>
    </div>
  </div>

  @if (showReservePopup) {
    <app-reserve-table-popup
      [minPricePerPerson]="350"
      [restaurantId]="diningData?._id"
      (closePopup)="closeReservePopup()"
      (confirmBooking)="handleReservation($event)"
    >
    </app-reserve-table-popup>
  }

  @if (showTakeawayPopup) {
    <app-takeaway-popup
      (closePopup)="closeTakeawayPopup()"
      (orderPlaced)="handleOrder($event)"
      [dishes]="dishes"
      [restaurantId]="diningData?._id"
      [gst]="gst"
    >
    </app-takeaway-popup>
  }

  <div class="container">
    <div class="mb-3">
      <div class="grid-container">
        @for (img of diningData?.gallery; track img; let i = $index) {
          <div class="grid-item" [ngClass]="'item' + (i + 1)">
            <img [src]="img?.cdnUrl" [alt]="'gallery ' + (i + 1)" />
          </div>
        }
      </div>
    </div>

    <div class="col-md-9 mx-auto mt-5 menu-section">
      <img
        src="assets/images/menu-qr.png"
        alt="Menu QR"
        style="width: 100%; height: 400px; object-fit: contain"
      />

      <div class="menu-download-action">
        <button
          class="menu-download-btn"
          (click)="downloadMenuPdf()"
          [disabled]="downloadingMenuPdf"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 3v10"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M8 11l4 4 4-4"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 21h16"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>

          <span>
            {{ downloadingMenuPdf ? "Downloading Menu..." : "Download Menu" }}
          </span>
        </button>
      </div>
    </div>

    <div class="contact-outer">
      <div class="contact-wrapper">
        <div class="map">
          <iframe
            width="100%"
            height="300"
            [src]="safeMapUrl"
            style="border: 0"
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          >
          </iframe>
        </div>

        <div class="info">
          <div class="info-top">
            <h2>Grains Pure Veg by<br />{{ diningData?.name }}</h2>
            <div class="underline heading-line"></div>

            <p>
              @if (diningData?.address) {
                {{ diningData?.address }}
              } @else {
                Hill Cart Rd, Kakjhora, Darjeeling,<br />
                West Bengal 734101
              }
            </p>

            <p>
              For Booking & Query<br />
              <a href="tel:+917719368489">+91 77193 68489</a>
            </p>
          </div>

          <div class="info-bottom">
            <p>Follow Us On</p>
            <div class="underline social-line"></div>
            <div class="icons">
              <a
                href="https://www.facebook.com/udaanhotels"
                target="_blank"
                aria-label="Facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38.797"
                  height="38.797"
                  viewBox="0 0 38.797 38.797"
                >
                  <path
                    d="M33.948,0H4.85A4.855,4.855,0,0,0,0,4.85v29.1A4.855,4.855,0,0,0,4.85,38.8h29.1a4.855,4.855,0,0,0,4.85-4.85V4.85A4.855,4.855,0,0,0,33.948,0Z"
                    fill="#1976d2"
                  />
                  <path
                    d="M210.186,108.124h-6.062v-4.85c0-1.339,1.086-1.212,2.425-1.212h2.425V96h-4.85a7.274,7.274,0,0,0-7.274,7.275v4.85H192v6.062h4.85v13.337h7.274V114.186h3.637Z"
                    transform="translate(-177.451 -88.725)"
                    fill="#fafafa"
                  />
                </svg>
              </a>

              <a
                href="https://www.instagram.com/udaanhotels/"
                target="_blank"
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38.797"
                  height="38.797"
                  viewBox="0 0 38.797 38.797"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      x1="0.084"
                      y1="0.916"
                      x2="0.916"
                      y2="0.084"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stop-color="#ffd600" />
                      <stop offset="0.5" stop-color="#ff0100" />
                      <stop offset="1" stop-color="#d800b9" />
                    </linearGradient>
                    <linearGradient
                      id="linear-gradient-2"
                      x1="0.146"
                      y1="0.854"
                      x2="0.854"
                      y2="0.146"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stop-color="#ff6400" />
                      <stop offset="0.5" stop-color="#ff0100" />
                      <stop offset="1" stop-color="#fd0056" />
                    </linearGradient>
                    <linearGradient
                      id="linear-gradient-3"
                      x1="0.146"
                      y1="0.854"
                      x2="0.854"
                      y2="0.146"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stop-color="#f30072" />
                      <stop offset="1" stop-color="#e50097" />
                    </linearGradient>
                  </defs>

                  <path
                    d="M38.681,11.4a14.242,14.242,0,0,0-.9-4.709,9.507,9.507,0,0,0-2.237-3.436,9.51,9.51,0,0,0-3.436-2.238A14.239,14.239,0,0,0,27.4.117C25.328.022,24.667,0,19.4,0s-5.929.022-8,.117a14.243,14.243,0,0,0-4.709.9A9.507,9.507,0,0,0,3.256,3.256,9.509,9.509,0,0,0,1.018,6.692a14.241,14.241,0,0,0-.9,4.709C.022,13.469,0,14.13,0,19.4s.022,5.929.117,8a14.238,14.238,0,0,0,.9,4.709,9.506,9.506,0,0,0,2.237,3.436,9.5,9.5,0,0,0,3.436,2.237,14.234,14.234,0,0,0,4.709.9c2.069.094,2.73.117,8,.117s5.929-.022,8-.117a14.236,14.236,0,0,0,4.709-.9,9.917,9.917,0,0,0,5.673-5.673,14.237,14.237,0,0,0,.9-4.709c.094-2.069.117-2.73.117-8S38.775,13.469,38.681,11.4ZM35.189,27.238a10.733,10.733,0,0,1-.668,3.6,6.424,6.424,0,0,1-3.682,3.682,10.733,10.733,0,0,1-3.6.668c-2.045.094-2.659.113-7.839.113s-5.794-.02-7.839-.113a10.736,10.736,0,0,1-3.6-.668,6.012,6.012,0,0,1-2.23-1.451,6.009,6.009,0,0,1-1.451-2.23,10.733,10.733,0,0,1-.668-3.6C3.515,25.192,3.5,24.579,3.5,19.4s.02-5.793.113-7.839a10.741,10.741,0,0,1,.668-3.6A6.014,6.014,0,0,1,5.727,5.727,6.006,6.006,0,0,1,7.958,4.276a10.731,10.731,0,0,1,3.6-.668C13.605,3.515,14.219,3.5,19.4,3.5h0c5.18,0,5.793.02,7.839.113a10.735,10.735,0,0,1,3.6.668,6.015,6.015,0,0,1,2.23,1.451,6.006,6.006,0,0,1,1.451,2.231,10.723,10.723,0,0,1,.668,3.6c.093,2.045.113,2.659.113,7.839S35.282,25.192,35.189,27.238Zm0,0"
                    fill="url(#linear-gradient)"
                  />
                  <path
                    d="M134.5,124.539a9.961,9.961,0,1,0,9.962,9.962A9.962,9.962,0,0,0,134.5,124.539Zm0,16.428a6.466,6.466,0,1,1,6.466-6.466A6.466,6.466,0,0,1,134.5,140.967Zm0,0"
                    transform="translate(-115.102 -115.102)"
                    fill="url(#linear-gradient-2)"
                  />
                  <path
                    d="M366.585,90.953a2.328,2.328,0,1,1-2.328-2.328A2.328,2.328,0,0,1,366.585,90.953Zm0,0"
                    transform="translate(-334.504 -81.909)"
                    fill="url(#linear-gradient-3)"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
